export const mediaQueries = {
    xs: '@media (max-width: 767px)',
    notXs: '@media (min-width: 768px)',
    sm: '@media (min-width: 768px)',
    md: '@media (min-width: 992px)',
    lg: '@media (min-width: 1200px)',

    width: () => global.innerWidth || global.document.documentElement.clientWidth || global.document.body.clientWidth,
    isNotXs: function() { return this.width() > 767 },
    isXs: function() { return this.width() < 768 }
}


// WEBPACK FOOTER //
// ./src/twd/media-queries.js